<template>
  <el-dialog
    id="audio-preview"
    width="50%"
    title="Audio Preview"
    destroy-on-close
    :visible.sync="internalVisible"
    @close="handleClose"
  >
    <div v-if="note">
      <div class="modal-meta">
        <div class="meta-item">
          <i class="el-icon-user"></i>
          <span>{{ note.sender }}</span>
        </div>
        <div class="meta-item" v-if="note.location">
          <i class="el-icon-location"></i>
          <span>{{ note.location }}</span>
        </div>
        <div class="meta-item">
          <i class="el-icon-time"></i>
          <span>{{ formatDate(note.timestamp) }}</span>
        </div>
        <div class="meta-item" v-if="note.score">
          <el-rate
            :value="note.score"
            disabled
            :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
            text-color="#ff9900"
          />
        </div>
        <div class="meta-badges">
          <el-tag v-if="note.approved" size="mini" type="success" effect="dark">
            <i class="fa fa-podcast"></i> On Air
          </el-tag>
          <el-tag v-if="note.flagged" size="mini" type="danger" effect="dark">
            <i class="fa fa-flag"></i> Flagged
          </el-tag>
          <el-tag v-if="note.tone" size="mini" type="info">
            {{ capitalize(note.tone) }}
          </el-tag>
        </div>
      </div>

      <div class="audio-player" v-if="note.audioUrl">
        <audio controls :src="note.audioUrl" style="width: 100%"></audio>
      </div>

      <el-divider content-position="left"> <i class="el-icon-document"></i> Transcript </el-divider>
      <el-card class="transcript-card" shadow="never">
        <span class="transcript-text">{{ note.transcript || 'No transcript available.' }}</span>
      </el-card>

      <div class="meta-section" v-if="note.tags && note.tags.length">
        <el-divider content-position="left">
          <i class="el-icon-collection-tag"></i> Tags
        </el-divider>
        <div class="tag-list">
          <el-tag v-for="tag in note.tags" :key="tag" size="mini" type="warning" effect="plain">{{
            tag
          }}</el-tag>
        </div>
      </div>

      <div class="meta-section" v-if="note.people && note.people.length">
        <el-divider content-position="left">
          <i class="el-icon-user"></i> People Mentioned
        </el-divider>
        <div class="tag-list">
          <el-tag
            v-for="person in note.people"
            :key="person"
            size="mini"
            type="info"
            effect="plain"
          >
            <i class="el-icon-user"></i> {{ person }}
          </el-tag>
        </div>
      </div>

      <div class="meta-section" v-if="note.keywords && note.keywords.length">
        <el-divider content-position="left">
          <i class="el-icon-price-tag"></i> Keywords
        </el-divider>
        <div class="tag-list">
          <el-tag
            v-for="keyword in note.keywords"
            :key="keyword"
            size="mini"
            type="success"
            effect="plain"
            >{{ keyword }}</el-tag
          >
        </div>
      </div>
    </div>

    <div slot="footer">
      <el-button size="small" @click="handleClose">Close</el-button>
    </div>
  </el-dialog>
</template>

<script>
import moment from 'moment';
import { capitalize } from 'lodash';

export default {
  name: 'AudioPreviewModal',
  props: {
    visible: { type: Boolean, required: true },
    note: { type: Object, default: null },
  },
  computed: {
    internalVisible: {
      get() {
        return this.visible;
      },
      set(v) {
        this.$emit('update:visible', v);
      },
    },
  },
  methods: {
    capitalize,
    formatDate(timestamp) {
      return moment(timestamp).format('DD MMM YYYY, HH:mm');
    },
    handleClose() {
      this.internalVisible = false;
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.modal-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding: 12px;
  background: #f9f9f9;
  border-radius: 6px;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #606266;
}

.meta-badges {
  margin-left: auto;
  display: flex;
  gap: 6px;
}

.audio-player {
  margin-bottom: 16px;
}

.transcript-card {
  max-height: 200px;
  overflow-y: auto;
}

.transcript-text {
  font-size: 13px;
  line-height: 1.6;
  color: #606266;
}

.meta-section {
  margin-top: 8px;
}

.tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
</style>


// WEBPACK FOOTER //
// AudioPreviewModal.vue?0a45a269